export const toState = (state) => ({
    ...state,
    ...!state.change ? {
        change: (fn) => state.onChange(fn(state.value)),
    } : !state.onChange && {
        onChange: (v1) => state.change(() => v1),
    },
})
